// BFF: ○ gap — legacy referralSteerage* endpoints. The steerage view has no bff/crm module.
export { default as SteerageRelatedView } from './SteerageRelatedView'
